export const thankYou = {
  'thankYou.title': 'Hvala!',
  'thankYou.message': 'Uspešno ste zaključili registracijski vprašalnik.',
  'thankYou.description': 'Preferenca je poseben zaposlitveni portal, kjer imajo vsi kandidati močne reference. Pravkar ste zaključili registracijski proces. Kaj sledi? Preverite in izpolnite svoj profil podjetja, da vas lahko potencialni kandidati bolje spoznajo. Ko z njim zaključite, se lahko posvetite iskanju kandidatov.',
  'thankYou.button': 'Pojdi na profil podjetja',
}
